<template>
  <section class="navbar">
    <div class="navbar__container"><a :href="Content.en_gb.navbar.logoLink"><img
          src="data:image/png;base64,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"
          alt="justeat" class="navbar__container--logo"></a>
    </div>

  </section>
</template>
<script>
import Content from "../data/content.js";

export default {

  name: "Navbar",


  data: function () {
    return {
      Content
    }
  }


};
</script>



<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.navbar {
  margin-bottom: -10px;
  background-color: var(--color-orange-1);
  padding: 20px 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;

  &__left {
    display: flex;
    align-items: flex-end;
    line-height: 1.1;

    &:hover {
      transform: scale(1.02);
    }

    @media (max-width: $tablet) {
      flex-direction: column;
      width: 60%;
      align-items: flex-start;
    }

    &--logo {
      width: 250px;
      margin: 0;
      cursor: pointer;

      @media (max-width: $tablet) {
        width: 150px;
        padding: 0;
      }
    }

    &--title {
      color: var(--color-white-1);
      font-weight: 600;

      @media (max-width: $tablet) {
        flex-direction: column;
        padding: 10px 0;
      }
    }
  }

  &__right {
    display: flex;
    align-items: self-start;

    &--button {
      padding: 8px;
      background-color: transparent;
      border: 2px solid var(--color-white-1);
      border-radius: 30px;
      cursor: pointer;
      color: var(--color-white-1);
      text-decoration: none;
      display: flex;
      max-width: 200px;
      justify-content: space-evenly;
      align-items: center;

      img {
        margin-right: 2px;
      }

      &:hover {
        transform: scale(1.03);
      }
    }

    &--toggle {
      margin: 0 10px 0 0;
      padding: 0;
      cursor: pointer;

      &:hover {
        transform: scale(1.03);
      }

      img {
        width: 50px;
        border-radius: 30px;
        border: 2px solid var(--color-white-1);
      }
    }

    &--list {
      background-color: var(--color-white-1);
      padding: 10px 10px 5px;
      border-radius: 30px;
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 80px;
      right: 5%;

      img {
        width: 50px;
        border-radius: 30px;
        margin: 0;

        &:hover {
          transform: scale(1.03);
        }
      }
    }
  }
}
</style>